"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSecretManagerService = exports.SecretKeys = void 0;
const config_1 = require("./config");
var SecretKeys;
(function (SecretKeys) {
    SecretKeys["ACCOUNTS_SERVER_ACCESS"] = "ACCOUNTS_SERVER_ACCESS";
    SecretKeys["APOLLO_KEY"] = "APOLLO_KEY";
    SecretKeys["OKTA_TOKEN"] = "OKTA_TOKEN";
    SecretKeys["CORP_OKTA_TOKEN"] = "CORP_OKTA_TOKEN";
    SecretKeys["GOOGLE_CLIENT_SECRET"] = "GOOGLE_CLIENT_SECRET";
    SecretKeys["GOOGLE_REFRESH_TOKEN"] = "GOOGLE_REFRESH_TOKEN";
    SecretKeys["VIRUS_SCAN_TOKEN"] = "VIRUS_SCAN_TOKEN";
    SecretKeys["PGPASSWORD"] = "PGPASSWORD";
    SecretKeys["ADS_DB_PASSWORD"] = "ADS_DB_PASSWORD";
    SecretKeys["SISENSE_SECRET_KEY"] = "SISENSE_SECRET_KEY";
    SecretKeys["SISENSE_PASSWORD"] = "SISENSE_PASSWORD";
    SecretKeys["HUB_ANALYTICS_DATA_PASSWORD"] = "HUB_ANALYTICS_DATA_PASSWORD";
    SecretKeys["HUB_BUSINESS_DATA_PASSWORD"] = "HUB_BUSINESS_DATA_PASSWORD";
    SecretKeys["TABLEAU_ONLINE_ADMIN_PASSWORD"] = "TABLEAU_ONLINE_ADMIN_PASSWORD";
    SecretKeys["RESOLVER_API_KEY"] = "RESOLVER_API_KEY";
    SecretKeys["BI_API_KEY"] = "BI_API_KEY";
    SecretKeys["REPORT_SERVER_API_KEY"] = "REPORT_SERVER_API_KEY";
    SecretKeys["REPORT_SERVER_OUT_API_KEY"] = "REPORT_SERVER_OUT_API_KEY";
    SecretKeys["CX_ETL_API_KEY"] = "CX_ETL_API_KEY";
    SecretKeys["AUTHORING_SERVER_API_KEY"] = "AUTHORING_SERVER_API_KEY";
    SecretKeys["ZENDESK_API_TOKEN"] = "ZENDESK_API_TOKEN";
    SecretKeys["RAAS_SLUG_API_TOKEN"] = "RAAS_SLUG_API_TOKEN";
    SecretKeys["SHOPIFY_API_KEY"] = "SHOPIFY_API_KEY";
    SecretKeys["GETTY_API_KEY"] = "GETTY_API_KEY";
    SecretKeys["GETTY_API_SECRET"] = "GETTY_API_SECRET";
    SecretKeys["STRESS_TEST_API_KEY"] = "STRESS_TEST_API_KEY";
    SecretKeys["PERFORMANCE_TOOL_API_KEY"] = "PERFORMANCE_TOOL_API_KEY";
    SecretKeys["RAAS_API_KEY_GENERATOR"] = "RAAS_API_KEY_GENERATOR";
    SecretKeys["ANALYTICS_DATA_FETCHER_API_KEY"] = "ANALYTICS_DATA_FETCHER_API_KEY";
    SecretKeys["SOCIAL_SERVICE_X_API_KEY"] = "SOCIAL_SERVICE_X_API_KEY";
    SecretKeys["ASSET_SERVICE_API_TOKEN"] = "ASSET_SERVICE_API_TOKEN";
    SecretKeys["CORD_SECRET_KEY"] = "CORD_SECRET_KEY";
    SecretKeys["STORYBLOCKS_API_KEY"] = "STORYBLOCKS_API_KEY";
    SecretKeys["STORYBLOCKS_SECRET_KEY"] = "STORYBLOCKS_SECRET_KEY";
    SecretKeys["AUTH0_API_CLIENT_SECRET"] = "AUTH0_API_CLIENT_SECRET";
    SecretKeys["AI_TEXT_SERVICES_API_KEY"] = "AI_TEXT_SERVICES_API_KEY";
    SecretKeys["HOBBIT_API_KEY"] = "HOBBIT_API_KEY";
    SecretKeys["RAAS_API_KEY"] = "RAAS_API_KEY";
    SecretKeys["RAAS_PREVIEW_API_KEY"] = "RAAS_PREVIEW_API_KEY";
    SecretKeys["COGNITO_USER_POOL_JWT_SET"] = "COGNITO_USER_POOL_JWT_SET";
    SecretKeys["CONVERGENCE_PRIVATE_KEY"] = "CONVERGENCE_PRIVATE_KEY";
    SecretKeys["GETTY_AI_IMAGE_API_KEY"] = "GETTY_AI_IMAGE_API_KEY";
    SecretKeys["GETTY_AI_IMAGE_SECRET"] = "GETTY_AI_IMAGE_SECRET";
    SecretKeys["GOOGLE_AI_IMAGE_PRIVATE_KEY"] = "GOOGLE_AI_IMAGE_PRIVATE_KEY";
    SecretKeys["GOOGLE_AI_IMAGE_PRIVATE_KEY_ID"] = "GOOGLE_AI_IMAGE_PRIVATE_KEY_ID";
    SecretKeys["GOOGLE_AI_IMAGE_CLIENT_ID"] = "GOOGLE_AI_IMAGE_CLIENT_ID";
    SecretKeys["IN_APP_HELP_CENTER_ZENDESK_API_TOKEN"] = "IN_APP_HELP_CENTER_ZENDESK_API_TOKEN";
    SecretKeys["EXPORT_ACCOUNT_ZIP_PASSWORD"] = "EXPORT_ACCOUNT_ZIP_PASSWORD";
    SecretKeys["EXPORT_ACCOUNT_DATA_API_KEY"] = "EXPORT_ACCOUNT_DATA_API_KEY";
    SecretKeys["ACQUIA_CLIENT_ID"] = "ACQUIA_CLIENT_ID";
    SecretKeys["ACQUIA_CLIENT_SECRET"] = "ACQUIA_CLIENT_SECRET";
    SecretKeys["SALESFORCE_USER"] = "SALESFORCE_USER";
    SecretKeys["SALESFORCE_PASSWORD"] = "SALESFORCE_PASSWORD";
})(SecretKeys || (exports.SecretKeys = SecretKeys = {}));
const region = process.env.REGION || "us-east-1";
const environment = config_1.env || "dev";
const secretName = `studio-${environment}`;
let secretManager;
// This is a list of FIELDS that can/should be overridden using environment variable (for example, for developers)
const OVERRIDABLE_FIELDS = [
    SecretKeys.PGPASSWORD,
    SecretKeys.ADS_DB_PASSWORD,
    SecretKeys.SISENSE_SECRET_KEY,
    SecretKeys.RAAS_API_KEY,
    SecretKeys.RAAS_PREVIEW_API_KEY
];
const OVERRIDING_SECRETS = OVERRIDABLE_FIELDS.reduce((acc, field) => {
    let value = process.env[field];
    if (value) {
        acc[field] = value;
    }
    return acc;
}, {});
const getSecretManagerService = () => __awaiter(void 0, void 0, void 0, function* () {
    // Lazy init
    if (!secretManager) {
        const commonSecretManager = require("@sundaysky/common-secrets-manager");
        secretManager = new commonSecretManager.SecretsManager(region);
    }
    const secretData = yield secretManager.getSecretValue(secretName);
    const secretsFromSecretManager = JSON.parse(secretData.secret);
    return Object.assign(Object.assign({}, secretsFromSecretManager), OVERRIDING_SECRETS);
});
exports.getSecretManagerService = getSecretManagerService;
//# sourceMappingURL=secretManagerService.js.map